<template>
  <div>
    <div v-if="display == 'kwok34'" class="kwokThreeFour"></div>
    <div v-if="display == 'kwok14'" class="kwokOneFour"></div>

    <div v-if="display == 'kwok23'" class="kwokTwoThree"></div>

    <div v-if="display == 'kwok12'" class="kwokOneTwo"></div>
    <div class="f-bet-lot">
      <div
        class="fantan-bet-lot-bet-no"
        :class="{ [size]: size }"
        justify="center"
      >
        {{ odd }}
      </div>
      <div class="fantan-bet-lot-cell">
        <div
          class="fantan-bet-lot-title"
          :class="{ [size]: size }"
          justify="center"
          align="middle"
        >
          <span class="typecolor1">{{ this.type.charAt(4) }}</span>
          <br />
          <span class="typecolor2">{{ this.type.charAt(5) }}</span>
        </div>
      </div>
    </div>
    <div v-if="stakeRecordSum" class="fantan-bet-lot-stake-total">
      {{ stakeRecord }}
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "game", "size", "stakeRecordSum", "display"],
  components: {
    Row,
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-kwok-three-four .f-bet-lot .typecolor1,
.fantan-kwok-three-two .f-bet-lot .typecolor2 {
  color: #f9cb62;
}

.fantan-kwok-one-four .f-bet-lot .typecolor2,
.fantan-kwok-three-four .f-bet-lot .typecolor2 {
  color: #fa4358;
}

.fantan-kwok-one-four .f-bet-lot .typecolor1,
.fantan-kwok-one-two .f-bet-lot .typecolor1 {
  color: #c9c9c9;
}

.fantan-kwok-one-two .f-bet-lot .typecolor2,
.fantan-kwok-three-two .f-bet-lot .typecolor1 {
  color: #16cc86;
}

.fantan-mainbet {
  background-color: #000000;
  position: relative;
  width: 100%;
  height: auto;
}

.divider {
  height: 10px;
  display: block;
  clear: both;
}

.square {
  width: 25%;
  float: left;
  background-color: black;
  position: relative;
}

svg {
  height: 100%;
  width: 100%;
}

polygon {
  stroke-linejoin: round;
  stroke: black;
  stroke-width: 5px;
  stroke-linejoin: round;
}

.top {
  fill: yellow;
}

.left {
  fill: red;
}

.bottom {
  // fill: white;
  display: block;
  margin: 0 auto;
  position: absolute;
  top: calc(50% - 14px);
  left: calc(50% - 14px);
}

.wordsOne {
  color: #c9c9c9;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsTwo {
  color: #16cc86;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsThree {
  color: #f9cb62;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsFour {
  color: #fa4358;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.open-result .fantan-bet-lot-cell-active {
  background: linear-gradient(to right, #1a6dbc, #52b2ff);
  color: #fff;
}

.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-title,
.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-bet-no {
  color: #fff;
  opacity: 1;
}

.f-bet-lot {
  // position: absolute;
  // top: 50%;
  left: 0;
  transform: translateX(0);
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
}

.fantan-kwok-three-two .f-bet-lot,
.fantan-kwok-one-two .f-bet-lot {
  flex-direction: row-reverse;
  // left: 0;
  // transform: translateX(0);
}

.fantan-bet-lot-cell {
  // width: 100%;
  text-align: center;
}

.fantan-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.fantan-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.fantan-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.fantan-bet-lot-title-left {
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}

.fantan-bet-lot-title-right {
  text-align: right;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}

.fantan-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.fantan-bet-lot-title {
  font-family: "Oswald";
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  // text-transform: uppercase;
  padding: 0 10px;
  line-height: 20px;
}

.fantan-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  margin-top: 0px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  font-family: "Oswald";
}

.fantan-bet-lot-bet-no.small {
  height: unset;
}
</style>

<style lang="scss">
.fantan-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

// @media only screen and (max-width: 360px) {
//   .fantan-bet-lot-cell {
//     padding: 6px 0;
//   }

//   .fantan-bet-lot-cell.large {
//     padding-bottom: 6px;
//   }

//   .fantan-bet-lot-title.large {
//     height: 32px;
//   }

//   .fantan-bet-lot-bet-no.large,
//   .fantan-bet-lot-bet-no.small {
//     margin-top: 6px;
//   }
// }
</style>
